const loads = new Map<string, Promise<void>>();

function loadSdkElement(url: string, tag: string, exportName: string, missingError: string): Promise<void> {
  if (customElements.get(tag)) return Promise.resolve();
  const key = `${tag}:${url}`;
  const existing = loads.get(key);
  if (existing) return existing;

  const loading = import(/* @vite-ignore */ url).then((module) => {
    const element = module[exportName];
    if (typeof element !== "function") throw new Error(missingError);
    if (!customElements.get(tag)) customElements.define(tag, element);
  }).catch((error: unknown) => {
    loads.delete(key);
    throw error;
  });
  loads.set(key, loading);
  return loading;
}

/** Load the SDK's shared, read-only result renderer for saved generations. */
export function loadRoomVisualizeResultSDK(url: string): Promise<void> {
  return loadSdkElement(url, "youzu-room-visualize-result", "YouzuRoomVisualizeResult",
    "The configured SDK does not include the saved result viewer.");
}

/** Load only the dedicated widget; keep the shared SDK and legacy elements intact. */
export function loadRoomVisualizeSDK(url: string): Promise<void> {
  return loadSdkElement(url, "youzu-room-visualize", "YouzuRoomVisualize",
    "The configured module does not export Room Visualizer.");
}
